'use client';

import { TenantBadge } from '@/app/dashboard/tenants/components/tenant-badge';
import { toMoneyString } from '@/lib/utils';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  TenantApplicantConfig,
  type Tenant,
  type TenantApplicant,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const TenantApplicantItem: RelationFieldProps<TenantApplicant> = {
  filters: [],
  nested: getRelationFieldNames(TenantApplicantConfig),
  renderItem: (item) => ({
    title: item.tenant?.communicationName ?? 'Saknar kommunikationsnamn',
    badge: <TenantBadge tenant={item.tenant as Tenant} />,
    descriptionItems: (
      <div className='grid w-full'>
        <span>Inkomst {toMoneyString(item.annualIncome)}</span>
        <span>Antal boende {item.numberOfResidentsForApplication ?? 0}</span>
      </div>
    ),
  }),
};
